const title = {
  id: 'helpCenterPage.drawer.title',
};

const textIds = {
  title,
};

export default textIds;
